import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component({
  computed: {
    setComment: {
      get () {
        if (this.answerLogs.isAnswered) {
          return this.answerLogs.answer
        } else {
          return this.comment
        }
      },
      set (value) {
        this.comment = value
      }
    }
  }
})
export default class HistorialQuestion extends Vue {
  @Prop({ default: () => {} }) answerLogs!: Object
  @Prop({ default: () => [] }) possibleAnswers!: Array<any>
  @Prop({ default: () => [] }) allAnswers!: Array<any>
  @Prop({ default: () => {} }) sendAnswer!: Function
  @Prop({ default: () => {} }) setAnswers!: Function
  @Prop({ default: '' }) kind!: String
  @Prop({ default: '' }) logo!: String
  @Prop({ default: '' }) show!: String
  @Prop({ default: '' }) questionType!: String
  @Prop({ default: 0 }) questionId!: Number
  @Prop({ default: false }) isServiceQuestion!: Boolean

  comment = ''

  get setTitle () {
    if (this.isServiceQuestion) {
      return 'Colaborador: '
    }
    return 'TodosComemos: '
  }

  clearComment (id: any, type: any) {
    let allAnswers = [...this.allAnswers]
    allAnswers.push({
      id,
      answer: this.comment,
      type
    })
    allAnswers.forEach((answer) => {
      this.sendAnswer(answer.answer, answer.id, answer.type)
    })
    this.comment = ''
  }

  calculateClass (text: any, type: any) {
    let typeAnswer = ''
    let typeActiveAnswer = ''
    let selected = ''
    switch (text) {
      case '1':
        typeAnswer = 'historial__calificar-malo'
        break
      case '2':
        typeAnswer = 'historial__calificar-regular'
        break
      case '3':
        typeAnswer = 'historial__calificar-bueno'
        break
      default:
        break
    }
    if ((this.answerLogs as any).answer === text) {
      typeActiveAnswer = 'active-answer'
    }
    // Search if it already selected
    this.allAnswers.forEach((answer) => {
      if (answer.answer === text && answer.id === this.questionId) {
        selected = 'active-answer'
      }
    })
    if (type === 'noAnswer') {
      return `${typeActiveAnswer} ${typeAnswer} ${selected}`
    } else {
      return `${typeAnswer} ${selected}`
    }
    
  }
}
